// extracted by mini-css-extract-plugin
module.exports = {"box":"App_box_28-0Y","content":"App_content_pIJBB"};